(function () {
  var STORAGE_KEY = 'sis_recently_viewed';
  var DEFAULT_LIMIT = 4;

  function getViewedHandles() {
    try {
      var stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return Array.isArray(stored) ? stored : [];
    } catch (e) {
      return [];
    }
  }

  function getHandlesInCart() {
    var handles = [];
    document.querySelectorAll('#CartDrawer-CartItems .cart-item__name').forEach(function (link) {
      var href = link.getAttribute('href') || '';
      var match = href.match(/\/products\/([a-z0-9\-]+)/i);
      if (match) handles.push(match[1]);
    });
    return handles;
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : str;
    return div.innerHTML;
  }

  function formatMoney(cents) {
  return '€' + (cents / 100).toFixed(2);
}

  function renderRecommendations() {
    var container = document.getElementById('CartDrawer-Recommendations');
    if (!container) return;

    var limit = parseInt(container.getAttribute('data-limit'), 10) || DEFAULT_LIMIT;
    var inCart = getHandlesInCart();
    var candidates = getViewedHandles()
      .filter(function (handle) {
        return inCart.indexOf(handle) === -1;
      })
      .slice(0, limit);

    if (candidates.length === 0) {
      container.innerHTML = '';
      return;
    }

    container.innerHTML =
      '<h3 class="cart-drawer__recommendations-title">What about these?</h3>' +
      '<div class="cart-drawer__recommendations-list"></div>';
    var list = container.querySelector('.cart-drawer__recommendations-list');

    candidates.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .then(function (product) {
          if (!product || !list) return;
          list.appendChild(buildRecommendationCard(product));
        })
        .catch(function () {});
    });
  }

  function buildRecommendationCard(product) {
    var card = document.createElement('div');
    card.className = 'cart-drawer__rec-card';

    var imageUrl = product.featured_image || (product.images && product.images[0]) || '';
    var hasMultipleVariants = product.variants.length > 1;
    var firstAvailable =
      product.variants.filter(function (v) {
        return v.available;
      })[0] || product.variants[0];

    card.innerHTML =
      '<a href="/products/' +
      product.handle +
      '" class="cart-drawer__rec-image-link">' +
      '<img src="' +
      imageUrl +
      '" alt="' +
      escapeHtml(product.title) +
      '" loading="lazy">' +
      '</a>' +
      '<div class="cart-drawer__rec-info">' +
      '<a href="/products/' +
      product.handle +
      '" class="cart-drawer__rec-title">' +
      escapeHtml(product.title) +
      '</a>' +
      '<span class="cart-drawer__rec-price">' +
      formatMoney(firstAvailable.price) +
      '</span>' +
      '</div>';

    var actionWrap = document.createElement('div');
    actionWrap.className = 'cart-drawer__rec-action';

    if (hasMultipleVariants) {
      var select = document.createElement('select');
      select.className = 'cart-drawer__rec-select';

      var placeholder = document.createElement('option');
      placeholder.textContent = 'Select size';
      placeholder.value = '';
      select.appendChild(placeholder);

      product.variants.forEach(function (variant) {
        var opt = document.createElement('option');
        opt.value = variant.id;
        opt.textContent = variant.available ? variant.title : variant.title + ' (Sold out)';
        opt.disabled = !variant.available;
        select.appendChild(opt);
      });

      select.addEventListener('change', function () {
        if (select.value) addToCart(select.value, card);
      });

      actionWrap.appendChild(select);
    } else {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'cart-drawer__rec-add button button--tertiary';
      button.textContent = firstAvailable.available ? 'Add' : 'Sold out';
      button.disabled = !firstAvailable.available;

      button.addEventListener('click', function () {
        addToCart(firstAvailable.id, card);
      });

      actionWrap.appendChild(button);
    }

    card.appendChild(actionWrap);
    return card;
  }

  function addToCart(variantId, card) {
    if (card) card.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function () {
        return fetch('/cart?section_id=cart-drawer');
      })
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newInner = doc.querySelector('.drawer__inner');
        var currentInner = document.querySelector('#CartDrawer .drawer__inner');

        if (newInner && currentInner) {
  currentInner.innerHTML = newInner.innerHTML;
  var cartDrawerRoot = document.querySelector('cart-drawer');
  if (cartDrawerRoot) cartDrawerRoot.classList.remove('is-empty');

  initTermsCheckbox();
  renderRecommendations();
  fixQuantityWidths();

          if (cartDrawerRoot && !cartDrawerRoot.classList.contains('active')) {
            cartDrawerRoot.classList.add('animate', 'active');
            document.body.classList.add('overflow-hidden');
          }
        }
      })
      .catch(function () {
        if (card) card.classList.remove('is-loading');
      });
  }

  function syncCheckoutButton() {
  var checkbox = document.getElementById('CartDrawer-AcceptTerms');
  var checkoutButton = document.getElementById('CartDrawer-Checkout');
  if (!checkbox || !checkoutButton) return;
  var cartEmpty = checkoutButton.getAttribute('data-cart-empty') === 'true';
  checkoutButton.disabled = !checkbox.checked || cartEmpty;
}

var termsCheckboxBound = false;

function initTermsCheckbox() {
  syncCheckoutButton();

  if (termsCheckboxBound) return;
  termsCheckboxBound = true;

  // Delegated on document: survives the checkbox being destroyed and recreated
  // by any cart re-render, regardless of what triggers it or when.
  document.addEventListener('change', function (event) {
    if (event.target && event.target.id === 'CartDrawer-AcceptTerms') {
      syncCheckoutButton();
    }
  });

  var cartDrawerRoot = document.getElementById('CartDrawer');
  if (cartDrawerRoot && window.MutationObserver) {
    var observer = new MutationObserver(function () {
      syncCheckoutButton();
    });
    observer.observe(cartDrawerRoot, { childList: true, subtree: true });
  }
}
 function init() {
  renderRecommendations();
  initTermsCheckbox();
  initClickOutside();
  fixQuantityWidths();
  subscribeToCartUpdates();
}

function subscribeToCartUpdates() {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
    initTermsCheckbox();
    fixQuantityWidths();
  });
}

function fixQuantityWidths() {
  document.querySelectorAll('.cart-drawer .quantity.cart-quantity').forEach(function (el) {
    el.style.removeProperty('width');
  });
}

function initClickOutside() {
  document.addEventListener('click', function (event) {
    var drawerRoot = document.querySelector('cart-drawer.active');
    if (!drawerRoot) return;
    var inner = drawerRoot.querySelector('.drawer__inner');
    var cartIcon = document.getElementById('cart-icon-bubble');
    if (inner && !inner.contains(event.target) && event.target !== cartIcon && !cartIcon.contains(event.target)) {
      drawerRoot.close();
    }
  });
}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('#cart-icon-bubble')) {
      setTimeout(function () {
        renderRecommendations();
        initTermsCheckbox();
      }, 350);
    }
  });
})();
